import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "page-layout"
};
import HeaderNav from '@/components/HeaderNav.vue';
import FooterNav from '@/components/FooterNav.vue';
export default {
  __name: 'PageLayout',
  emits: ['toggleDayNight'],
  setup(__props, {
    emit
  }) {
    const changeColor = checked => {
      emit('toggleDayNight', checked);
    };
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(HeaderNav, {
        onChangeColor: changeColor
      }), _createVNode(_component_router_view), _createVNode(FooterNav)]);
    };
  }
};